/* src/app/private/configrations/contact-group/contact-group.component.scss */
.active {
  background-color: var(--primary-color);
  color: #fff;
  font-weight: 600;
}
.item-name {
  max-width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.small-card {
  overflow-y: visible !important;
}
.right-box {
  background-color: var(--p-card-background);
  padding: 15px;
  border-radius: 10px;
  overflow-y: auto;
}
.right-box::-webkit-scrollbar {
  width: 8px !important;
}
.right-box::-webkit-scrollbar-thumb {
  background-color: var(--secondry-light-gray) !important;
  border-radius: 20px !important;
}
@media screen and (max-width: 768px) {
  .mobile-view {
    height: 85vh !important;
    overflow-y: auto !important;
  }
  .right-box {
    overflow-y: visible;
  }
}
/*# sourceMappingURL=contact-group.component.css.map */
